import { Stack, Typography } from '@mui/material'
import { t } from 'i18next'
import ModifyManyCarousel from './carousel/ModifyManyCarousel'
import PlanCarousel from './carousel/PlanCarousel'
import TrackedCarousel from './carousel/TrackedCarousel'
import DeleteCarousel from './carousel/DeleteCarousel'
import HistoryCarousel from './carousel/HistoryCarousel'

const ScheduleViewInfo = () => {
  return (
    <Stack sx={{ pt: 6, overflowX: 'hidden', overflowY: 'hidden' }} gap={1.5}>
      <Typography variant="h4" component="h1" color={'text.highEmphasis'}>
        {t('components.infoSidebar.schedule.title')}
      </Typography>

      <Stack>
        <PlanCarousel />
        <ModifyManyCarousel />
        <TrackedCarousel />
        <DeleteCarousel />
        <HistoryCarousel />
      </Stack>
    </Stack>
  )
}

export default ScheduleViewInfo
